const BASE_PATH = '/images';

export const IMAGES = {
  BASE_PATH,

  // Icons that are used in multiple places
  EXCLAMATION: `${BASE_PATH}/status/exclamation.svg`,
  PAYMENT_DECLINE: `${BASE_PATH}/payment/payment-decline.svg`,

  // Directory paths for dynamic usage
  PATHS: {
    LOGOS: `${BASE_PATH}/logos`,
    BENEFITS: `${BASE_PATH}/benefits`,
    EMPTY_STATE: `${BASE_PATH}/empty-state`,
    ONBOARDING: `${BASE_PATH}/onboarding`,
    PARTNERS: `${BASE_PATH}/partners`,
    PAYMENT_CARDS: `${BASE_PATH}/payment-cards`,
    TESTIMONIALS: `${BASE_PATH}/testimonials`,
    LOGIN_PROVIDERS: `${BASE_PATH}/login-providers`,
    SIDEBAR_BANNER: `${BASE_PATH}/sidebarBanner`,
    CHECKOUT: `${BASE_PATH}/checkout`,
    PAYMENT: `${BASE_PATH}/payment`,
    MODALS: `${BASE_PATH}/modals`,
    STATUS: `${BASE_PATH}/status`,
    MISC: `${BASE_PATH}/misc`,
  },
} as const;

export const DATA_URL_PREFIX = 'data:';
export const PNG_BASE64_PREFIX = 'data:image/png;base64,';
export const BLOB_URL_PREFIX = 'blob:';
